import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Navbar';
import './index.css';
import buildingImage from '../../assests/building.jpg';
import cafeInterior from '../../assests/cafe-interior.jpg';
// import whowearelogo1 from '../../assests/whowearelogo1.png';
import whoImg from '../../assests/who-img.png';
import founderimage from '../../assests/founderimage.png';
import shankarImage from '../../assests/shankar.jpeg';
import ramapriyanImage from '../../assests/ramapriyan.jpeg';
import architectureThatBelongs from '../../assests/architecture-that-belongs.jpeg';
// import buildtogetherbackground from '../../assests/buildtogetherbackground.png';

const About = () => {

  // Refs for scroll reveal
  const heroRef = useRef(null);
  const interiorRef = useRef(null);
  const reversedRef = useRef(null);
  const whoWeAreRef = useRef(null);
  const foundersRef = useRef(null);
  const ctaRef = useRef(null);



  // Intersection Observer for Scroll Reveal
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-visible');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe all sections
    const sections = [
      heroRef.current,
      interiorRef.current,
      reversedRef.current,
      whoWeAreRef.current,
      foundersRef.current,
      ctaRef.current
    ];

    sections.forEach(section => {
      if (section) {
        observer.observe(section);
      }
    });

    // Cleanup
    return () => {
      sections.forEach(section => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  return (
    <div className="aboutpage-about-container">
      {/* Shared Navigation Header */}
      <Navbar />

      {/* Main Content Section */}
      <main className="aboutpage-about-main">
        {/* First Section - Image Left, Text Right */}
        <section ref={heroRef} className="aboutpage-about-hero reveal-section">
          <div className="aboutpage-hero-image-container reveal-left">
            <img src={architectureThatBelongs} alt="Architecture Building" className="aboutpage-hero-building-image" />
          </div>

          <div className="aboutpage-hero-text-container reveal-right">
            <h1 className="aboutpage-hero-title">
              ARCHITECTURE THAT BELONGS,<br />
              <span className="aboutpage-hero-title-bold">DESIGN</span> THAT ENDURES
            </h1>

            <div className="aboutpage-hero-description">
              <p>
                At Lavanya & Shankar (LSA), every project begins with people—their values, their aspirations, their
                evolving lifestyles, and their dreams. Always designed with empathy, we create
                architecture that is personal, enduring, and deeply connected to its context. Our
                inspiration is rooted in local cultures, stories, and materials—layered with
                contemporary design sensibilities. We believe architecture is not just
                about building; it is about shaping experiences that help people live more
                meaningful, joyous, and fulfilled lives.
              </p>

              <p>
                At the heart of our practice lies a dialogue—between tradition and
                modernity, client and architect, idea and execution. We offer a holistic,
                collaborative approach to architecture and interior design, ensuring it's
                one seamless journey. Sensitive to both landscape and culture, our work
                reinterprets the familiar through a contemporary lens, creating spaces
                that feel grounded, graceful, and purposeful.
              </p>

              <p>
                For us, architecture is not just about building—it is about belonging. As a
                leading architecture and design studio in Chennai, we craft spaces that
                connect people, culture, and context—designed to inspire and built to
                endure.
              </p>
            </div>
          </div>
        </section>

        {/* Second Section - Full Width Cafe Interior Image */}
        <section ref={interiorRef} className="aboutpage-about-interior reveal-section">
          <div className="aboutpage-interior-image-container reveal-scale">
            <img src={cafeInterior} alt="Cafe Interior Design" className="aboutpage-interior-image" />
          </div>
        </section>

        {/* Third Section - Text Left, Image Right */}
        <section ref={reversedRef} className="aboutpage-about-reversed reveal-section">
          <div className="aboutpage-reversed-text-container reveal-left">
            <h2 className="aboutpage-reversed-title">
              Our Design <span className="aboutpage-reversed-title-bold">Philosophy</span>
            </h2>

            <div className="aboutpage-reversed-description">
              <p>
                Our design philosophy at LSA begins with empathy. We believe great architecture is born from understanding people—their habits, stories, and aspirations—and translating that understanding into meaningful spaces. Every design decision is rooted in context, shaped by culture, and guided by purpose.
              </p>

              <p>
                This approach balances tradition with innovation, combining local materials and craftsmanship with contemporary architectural design. We see architecture as an evolving dialogue—between light and structure, landscape and form, imagination and precision.
              </p>

              <p>
                As a Chennai-based architecture and interior design firm, we aim to create spaces that are not only visually timeless but emotionally resonant. Every project, whether a residence, commercial space, or institution, reflects our commitment to thoughtful design, environmental sensitivity, and lasting value.
              </p>
            </div>
          </div>

          <div className="aboutpage-reversed-image-container reveal-right">
            <img src={buildingImage} alt="Architectural Design" className="aboutpage-reversed-building-image" />
          </div>
        </section>

        {/* Fourth Section - Who We Are */}
        <section ref={whoWeAreRef} className="aboutpage-who-we-are reveal-section reveal-fade">
          <img src={whoImg} alt="Who We Are" className="aboutpage-who-logo" />


          <div className="aboutpage-who-content">
            <div className="aboutpage-who-text">
              {/* <p>
                A team of enthusiastic & aspiring designers at Studio LSA constantly endeavours to learn, adapt & evolve in trending architectures – supported by advanced technology adaptation, spreading happiness to several families & encouraging ables. The team constantly hones their skills by engaging in continuous learning programs, while upholding moral values & keeping the cost in check.
              </p>
              <p>
                Operating out of the 2000 sq ft. office space in Anna Salai, the team is equipped with state-of-the-art infrastructure for efficient & timely delivery. Associated with expert consultants who add value to all the projects the team has delivered to date, Studio LSA is equipped with top-tier Architects like Alliance Group, SoFDL, Shiva Charanya, Clasa Grande, Gayatri Builders, Akshaya Homes, Jaag Homes, Ruby Builders, Plaza and Shradha Academy.
              </p> */}
              <p>
                LSA has a passionate team of aspiring and forward-thinking designers who continuously strive to learn, adapt, and evolve with emerging architectural trends.
              </p>
              <p>Driven by innovation and supported by advanced technology, the team focuses on creating meaningful spaces that spread happiness, empower communities, and deliver lasting value. A strong commitment to ethical practices, skill enhancement through continuous learning, and cost-conscious execution defines their work culture.</p>
              {/* <p>
                Operating from a 2,000 sq. ft. state-of-the-art office on Anna Salai, Studio LSA is equipped with modern infrastructure that ensures efficient planning and timely project delivery. Collaborating with highly experienced consultants, the studio has successfully contributed to a wide range of projects alongside reputed organizations such as Alliance Group, SoFDL, Shiva Charanya, Clasa Grande, Gayatri Builders, Akshaya Homes, Jaag Homes, Ruby Builders, Plaza, and Shradha Academy.
              </p> */}
            </div>
          </div>
        </section>

        {/* Fifth Section - The Founders */}
        <section ref={foundersRef} className="aboutpage-founders reveal-section">
          <div className="aboutpage-founders-container">
            <h2 className="aboutpage-founders-title reveal-fade">KEY PEOPLE</h2>

            <div className="aboutpage-founders-grid">
              {/* Shankar - Founder */}
              <div className="aboutpage-founder-card reveal-bottom">
                <div className="aboutpage-founder-image-container">
                  <img src={shankarImage} alt="Shankar" className="aboutpage-founder-image" />
                </div>
                <h3 className="aboutpage-founder-name">SHANKAR</h3>
                <p className="aboutpage-founder-title">PRINCIPAL ARCHITECT</p>
                <div className="aboutpage-founder-bio">
                  <p>
                    Trained at Manipal Institute of Technology and seasoned with experiences at Chitale &amp; Sons and Ar. Savitha Idnani's Nakha, I carry forward a lineage of architectural excellence from my father, Mr. Sivaraman, whose portfolio includes several of Chennai's landmarks. My work interprets this heritage with a modern sensibility—redefining traditional craft and material in contemporary ways. I believe in architecture that responds to its site and context, evolving into spaces that are rooted, timeless, and relevant to the future.
                  </p>
                </div>
              </div>

              {/* Lavanya - Founder */}
              <div className="aboutpage-founder-card reveal-bottom">
                <div className="aboutpage-founder-image-container">
                  <img src={founderimage} alt="Lavanya" className="aboutpage-founder-image" />
                </div>
                <h3 className="aboutpage-founder-name">LAVANYA</h3>
                <p className="aboutpage-founder-title">DESIGN DIRECTOR- INTERIORS AND PLANNING</p>
                <div className="aboutpage-founder-bio">
                  <p>
                    As a Madras University rank-holder, my journey began with C.R. Narayana Rao Architects, where I learned to blend rigor with creativity. I thrive on infusing a touch of playfulness into every brief, shaping spaces that feel personal yet purposeful. My passion lies in interiors—the textures, finishes, and atmospheres that give projects their soul. For me, design is about making spaces feel alive, coherent, and beautifully human.
                  </p>
                </div>
              </div>

              {/* Third Founder */}
              <div className="aboutpage-founder-card reveal-bottom">
                <div className="aboutpage-founder-image-container">
                  <img src={ramapriyanImage} alt="Co-Founder" className="aboutpage-founder-image" />
                </div>
                <h3 className="aboutpage-founder-name">RAMAPRIYAN</h3>
                <p className="aboutpage-founder-title">DESIGN DIRECTOR ARCHITECTURE</p>
                <div className="aboutpage-founder-bio">
                  <p>
                    Architect and Project Management Professional with 29+ years of leadership experience in architectural design and large-scale project delivery across residential, commercial, healthcare, and hospitality sectors. A Manipal Institute of Technology graduate with a Bachelor of Architecture (First Class, University Rank 2), recognized for strategic design leadership, client and stakeholder management, sustainable practices, and successful end-to-end execution of complex developments.
                  </p>
                  {/* <p>
                    An accomplished Architect and Project Management Professional with over 29 years of experience across architectural design, design coordination, site supervision, and end-to-end project management. A graduate of Manipal Institute of Technology, holding a Bachelor of Architecture with First Class and University Rank 2, with proven ability to lead projects from concept to completion across residential, commercial, healthcare, hospitality, and real estate developments. Brings strong expertise in client and consultant coordination, property development, sustainable design, and building services, complemented by global exposure, cultural sensitivity, and a consistent record of delivering high client satisfaction.
                  </p> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Sixth Section - Let's Build Together CTA */}
        <section ref={ctaRef} className="build-together-cta reveal-section reveal-scale">
          <div className="build-together-cta__content">
            <h2 className="build-together-cta__title">LET'S BUILD TOGETHER</h2>
            <div className="build-together-cta__text">
              <p>
                Whether it's a home, a workplace, or a cultural landmark, we create environments that feel <br />
                alive and purposeful. <br />
                Let's begin a dialogue that shapes more than just structures—it shapes experiences.
              </p>
            </div>
            <Link to="/contact" className="build-together-cta__button">
              START A CONVERSATION
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
};

export default About;